import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconFlagEn = createIcon({
  viewBox: '0 0 22 22',
  path: (
    <>
      <circle cx="11" cy="11" r="11" fill="white" />
      <mask
        id="mask0"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="22"
        height="22"
      >
        <circle cx="11" cy="11" r="11" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M18.1822 23.7679H3.81836C0.733326 23.7679 -1.76758 21.267 -1.76758 18.182V3.81812C-1.76758 0.733082 0.733326 -1.76782 3.81836 -1.76782H18.1822C21.2672 -1.76782 23.7681 0.733082 23.7681 3.81812V18.182C23.7681 21.267 21.2672 23.7679 18.1822 23.7679Z"
          fill="#41479B"
        />
        <path
          d="M23.7685 18.1815V16.9552L19.8075 14.3601H23.7685V13.0161H13.0166V23.768H14.3606V15.6115L22.8857 21.197C23.1876 20.7269 23.4208 20.2085 23.5715 19.656"
          fill="#F5F5F5"
        />
        <path
          d="M-1.39197 20.1991C-1.25592 20.5502 -1.08564 20.8843 -0.88485 21.197L7.64029 15.6115V23.768H8.98425V13.0161H-1.76758V14.3601H2.1934L-1.76758 16.9552V18.1821C-1.76758 18.3968 -1.75501 18.6086 -1.73142 18.8171"
          fill="#F5F5F5"
        />
        <path
          d="M-1.76758 4.00799V5.04493L2.1934 7.64009H-1.76758V8.98406H8.9843V-1.76782H7.64034V6.38864L-0.88485 0.803205C-1.21617 1.31906 -1.46469 1.89306 -1.61227 2.50642"
          fill="#F5F5F5"
        />
        <path
          d="M23.3855 1.78169C23.2507 1.43761 23.0829 1.11008 22.8857 0.803155L14.3606 6.38864V-1.76782H13.0166V8.98406H23.7685V7.64009H19.8075L23.7685 5.04493V3.81812C23.7685 3.59568 23.7551 3.37633 23.7298 3.16067"
          fill="#F5F5F5"
        />
        <path
          d="M13.0163 -1.76782H8.9843V8.98406H-1.76758V13.016H8.9843V23.7679H13.0163V13.016H23.7681V8.98406H13.0163V-1.76782Z"
          fill="#FF4B55"
        />
        <path
          d="M5.13477 14.3599L-1.73145 18.8169C-1.67688 19.2988 -1.56117 19.7622 -1.39195 20.1989L7.60335 14.3599H5.13477V14.3599Z"
          fill="#FF4B55"
        />
        <path
          d="M15.4121 14.3599L23.5709 19.6559C23.699 19.1862 23.7678 18.6921 23.7678 18.1818V18.1813L17.8807 14.3599L15.4121 14.3599Z"
          fill="#FF4B55"
        />
        <path
          d="M6.29632 7.64002L-1.61227 2.50635C-1.71356 2.92709 -1.76758 3.36623 -1.76758 3.81805V4.00792L3.82774 7.64002H6.29632Z"
          fill="#FF4B55"
        />
        <path
          d="M16.8289 7.64009L23.7295 3.16067C23.6731 2.67968 23.5559 2.21734 23.3853 1.78174L14.3604 7.64009H16.8289Z"
          fill="#FF4B55"
        />
      </g>
    </>
  ),
});

export default IconFlagEn;
